module.exports = __webpack_public_path__ + "static/img/logo-home.1b1de71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-home.png
// module id = 1G6L
// module chunks = 14